export default {
    formatPrice(val) {
        if (val) {
            return val.toFixed(2);
        } else {
            return val;
        }
    },
    domainPrefix(val) {
        if (!val) return val;
        if (val.substr(0, 4) === "http") {
            return val;
        } else {
            return process.env.VUE_APP_BASE_API + val;
        }
    },
};
